<app-legal-layout [title]="title" [lastUpdated]="lastUpdated">
  <h2>1. Introducción</h2>
  <p>
    En <strong>velas.ar</strong> nos comprometemos a garantizar su satisfacción con nuestros productos. Esta Política de Devoluciones establece 
    los términos y condiciones bajo los cuales puede devolver o cambiar productos que haya adquirido en nuestro sitio web.
  </p>

  <h2>2. Período de Devolución</h2>
  <ul>
    <li><strong>Días hábiles:</strong> 10 días calendario desde la fecha de recepción del producto</li>
    <li><strong>Productos personalizados:</strong> Los productos hechos a medida pueden tener políticas diferentes (se informará al momento de la compra)</li>
    <li><strong>Estado del producto:</strong> El producto debe estar en su estado original, sin usar y con su empaque original</li>
  </ul>

  <h2>3. Requisitos para Devolución</h2>
  <p>Para procesar su devolución, debe cumplir con los siguientes requisitos:</p>
  <ul>
    <li>Contactarnos dentro del período de devolución (10 días)</li>
    <li>Proporcionar el número de pedido</li>
    <li>Indicar el motivo de la devolución</li>
    <li>Incluir todos los accesorios y documentación originales</li>
    <li>Mantener el producto en su embalaje original</li>
    <li>El producto no debe estar usado, dañado o alterado</li>
  </ul>

  <h2>4. Motivos Aceptables para Devolución</h2>
  <ul>
    <li>Producto defectuoso o dañado al recibirlo</li>
    <li>Producto incorrecto enviado (diferente al pedido)</li>
    <li>Producto no coincide con la descripción</li>
    <li>Arrepentimiento de compra (dentro del período permitido)</li>
  </ul>

  <h2>5. Productos No Elegibles para Devolución</h2>
  <ul>
    <li>Productos que han sido usados, dañados o alterados por el cliente</li>
    <li>Productos sin embalaje original o con embalaje dañado</li>
    <li>Productos personalizados o hechos a medida (salvo defectos)</li>
    <li>Productos de oferta, liquidación o descuento especial</li>
    <li>Velas que ya han sido encendidas</li>
  </ul>

  <h2>6. Proceso de Devolución</h2>
  
  <h3>Paso 1: Contacto</h3>
  <p>Comuníquese con nosotros para iniciar el proceso:</p>
  <ul>
    <li><strong>Email:</strong> info@velas.ar</li>
    <li><strong>Teléfono:</strong> +54 9 3329-564190</li>
    <li><strong>WhatsApp:</strong> <a href="https://wa.me/5493329564190">+54 9 3329-564190</a></li>
  </ul>

  <h3>Paso 2: Autorización</h3>
  <p>
    Revisaremos su solicitud y le proporcionaremos un número de autorización de devolución (RMA) si su solicitud es aprobada.
  </p>

  <h3>Paso 3: Envío</h3>
  <p>
    Deberá enviar el producto a nuestra dirección indicada. Le proporcionaremos las instrucciones de envío completas una vez que se apruebe su devolución.
  </p>

  <h2>7. Costos de Devolución</h2>
  <ul>
    <li><strong>Producto defectuoso/incorrecto:</strong> Nosotros cubrimos los costos de envío</li>
    <li><strong>Arrepentimiento:</strong> El cliente cubre los costos de envío de devolución</li>
    <li><strong>Productos dañados en tránsito:</strong> Contacte con la empresa de transporte</li>
  </ul>

  <h2>8. Procesamiento de Reembolsos</h2>
  
  <h3>8.1. Forma de Reembolso</h3>
  <ul>
    <li>Los reembolsos se realizarán en el mismo método de pago utilizado para la compra original</li>
    <li>El proceso puede tardar entre 5 a 10 días hábiles</li>
  </ul>

  <h3>8.2. Monto del Reembolso</h3>
  <ul>
    <li><strong>Producto completo:</strong> Reembolso total del precio de compra</li>
    <li><strong>Producto con accesorios faltantes:</strong> Reembolso parcial</li>
    <li><strong>Arrepentimiento:</strong> Reembolso del precio de compra menos costos de envío de devolución</li>
  </ul>

  <h2>9. Cambios de Productos</h2>
  <p>Si desea cambiar un producto por otro:</p>
  <ul>
    <li>Contacte con nosotros dentro del período de devolución</li>
    <li>Proporcione el número de pedido y el producto deseado</li>
    <li>Procesaremos el cambio una vez que recibamos el producto original</li>
    <li>Las diferencias de precio deberán ser pagadas adicionalmente</li>
  </ul>

  <h2>10. Productos Defectuosos</h2>
  <p>
    Si recibe un producto defectuoso o dañado, contáctenos inmediatamente. Nos haremos cargo de todos los costos de envío y le enviaremos un 
    reemplazo sin costo adicional.
  </p>

  <h2>11. Tiempo de Procesamiento</h2>
  <ul>
    <li><strong>Revisión de solicitud:</strong> 2-3 días hábiles</li>
    <li><strong>Recepción del producto:</strong> 3-5 días hábiles desde el envío</li>
    <li><strong>Procesamiento de reembolso:</strong> 5-10 días hábiles después de la recepción</li>
    <li><strong>Total estimado:</strong> 10-18 días hábiles</li>
  </ul>

  <h2>12. Política Especial para Velas</h2>
  <p>
    Nuestras velas artesanales son productos únicos hechos a mano. Tenga en cuenta:
  </p>
  <ul>
    <li>No aceptamos devoluciones de velas que ya han sido encendidas</li>
    <li>Las variaciones menores de color o textura son normales en productos artesanales</li>
    <li>Las imágenes son representativas y pueden variar ligeramente del producto final</li>
    <li>Las velas personalizadas solo pueden devolverse por defectos de fabricación</li>
  </ul>

  <h2>13. Garantía de Calidad</h2>
  <p>
    Todos nuestros productos están garantizados contra defectos de fabricación por un período de 30 días desde la fecha de compra. 
    Esta garantía no cubre daños por uso normal o desgaste esperado.
  </p>

  <h2>14. Contacto</h2>
  <p>Para iniciar una devolución o hacer consultas:</p>
  <ul>
    <li><strong>Email:</strong> info@velas.ar</li>
    <li><strong>Teléfono:</strong> +54 9 3329-564190</li>
    <li><strong>WhatsApp:</strong> <a href="https://wa.me/5493329564190">+54 9 3329-564190</a></li>
    <li><strong>Dirección:</strong> Baradero, Buenos Aires, Argentina</li>
  </ul>

  <h2>15. Modificaciones</h2>
  <p>
    Nos reservamos el derecho de modificar esta Política de Devoluciones en cualquier momento. Los cambios entrarán en vigencia inmediatamente 
    después de su publicación en el sitio web.
  </p>

  <p style="margin-top: 3rem; padding-top: 2rem; border-top: 2px solid #ad5d56;">
    <strong>Gracias por elegir velas.ar. Estamos comprometidos con su satisfacción.</strong>
  </p>
</app-legal-layout>

